var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.625 169.375L342.625 9.375C336.375 3.125 328.188 0 320 0S303.625 3.125 297.375 9.375C284.875 21.875 284.875 42.125 297.375 54.625L304.35 61.602L32.936 332.625C-5.814 371.375 -12.189 434.625 23.561 476.125C44.078 500 72.764 512 101.488 512H101.936C128.311 512 154.686 502 174.811 481.875L450.01 207.258L457.375 214.625C463.625 220.875 471.813 224 480 224S496.375 220.875 502.625 214.625C515.125 202.125 515.125 181.875 502.625 169.375ZM310.559 256H200.248L349.572 106.891L349.602 106.859L404.75 162.008L310.559 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVial);
export default __webpack_public_path__ + "static/media/vial.0e5e255ac72fa35c69194c4b463dd5c4.svg";
export { ForwardRef as ReactComponent };